// Retainer Actions Component
// Generate retainer agreements (English and Bilingual)

import { Button } from '@/components/ui/button';
import { FileSignature, Globe, Loader2 } from 'lucide-react';

const RetainerActions = ({ 
  intake, 
  generating, 
  onGenerate 
}) => {
  return (
    <div className="mt-3 space-y-2">
      <Button
        onClick={() => onGenerate(false)}
        disabled={generating}
        className="w-full bg-purple-600 hover:bg-purple-700 text-white"
        size="lg"
        data-testid="generate-retainer-btn"
      >
        {generating ? (
          <Loader2 className="w-5 h-5 mr-2 animate-spin" />
        ) : (
          <FileSignature className="w-5 h-5 mr-2" />
        )}
        {generating ? 'Generating...' : 'Generate Retainer (English)'}
      </Button>
      
      {/* Bilingual Retainer Option for non-English clients */}
      {intake.detected_language && intake.detected_language !== 'en' && (
        <Button
          onClick={() => onGenerate(true)}
          disabled={generating}
          variant="outline"
          className="w-full border-purple-400 text-purple-700 hover:bg-purple-50"
          size="lg"
          data-testid="generate-bilingual-retainer-btn"
        >
          {generating ? (
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
          ) : (
            <Globe className="w-5 h-5 mr-2" />
          )}
          Bilingual (English + {intake.detected_language_name})
        </Button>
      )}
      
      {intake.retainer_generated && (
        <p className="text-xs text-slate-500 mt-2 text-center">
          Retainer previously generated
        </p>
      )}
    </div>
  );
};

export default RetainerActions;
